import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchData } from '../../Services/apiService.js';
import { apiUrl } from '../../config/api.js';
import './Banner.css';

const Banner = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const eventData = await fetchData(apiUrl('ByType/Courses/Level 0'));
        setEvents(eventData);
      } catch (error) {
        console.error('Unable to load upcoming programs:', error);
      }
    };

    fetchEvents();
  }, []);

  return (
    <section className="home-hero">
      <div className="home-hero__overlay">
        <div className="container home-hero__container">
          <div className="home-hero__content">
            <span className="home-hero__eyebrow">Build wealth with knowledge</span>
            <h1>Invest with clarity.<br /><em>Trade with confidence.</em></h1>
            <p>Practical stock-market education, clear strategies, and a learning community that helps you move forward with purpose.</p>
          </div>

          {events.length > 0 && (
            <div className="home-hero__events" aria-label="Upcoming programs">
              <div className="home-hero__events-heading">
                <span>Upcoming learning sessions</span>
                <span>{events.length} available</span>
              </div>
              <div className="home-hero__events-list">
                {events.slice(0, 3).map((course) => (
                  <Link className="home-hero__event" to={`ApplyCourse/1/${course.CourseID}`} key={course.CourseID}>
                    <div>
                      <strong>{course.CourseTitle}</strong>
                      <span>{course.CourseDate} · {course.Time}</span>
                    </div>
                    <span className="home-hero__event-arrow" aria-hidden="true">↗</span>
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export { Banner };
